import URL from '../URL';
export const getBunnyOptimizedImageUri = (uri, { aspectRatio, height, width } = {}) => {
    if (!uri)
        return undefined;
    try {
        const parsed = new URL(uri);
        if (aspectRatio) {
            const aspectRatioFormat = /^\d+(\.\d+)?:\d+(\.\d+)?$/;
            if (aspectRatioFormat.test(aspectRatio)) {
                parsed.searchParams.append('aspect_ratio', aspectRatio);
            }
        }
        if (height) {
            parsed.searchParams.append('height', Math.ceil(height).toString());
        }
        else if (width) {
            parsed.searchParams.append('width', Math.ceil(width).toString());
        }
        return parsed.toString();
    }
    catch (err) {
        return uri;
    }
};
//# sourceMappingURL=getBunnyOptimizedImageUri.js.map